import React , { ReactElement } from 'react';
import Link from 'next/link';
import styles from './RestaurantCard.module.scss';
import LinesEllipsis from 'react-lines-ellipsis/lib/loose';
import { useOrientations } from '@common/hooks/useOrientation';
import { ISrcSet, Picture } from '@kursk/components/ui/Picture/Picture';
import { IRestaurant } from "@common/redux/types/places";
import { themeValue } from "@kursk/themes";

interface IRestaurantCardProps {
  restaurant: IRestaurant;
}

export function RestaurantCard({ restaurant }: IRestaurantCardProps): ReactElement {
  const orientation = useOrientations();
  const imgSrcSet: ISrcSet[] = [
    {
      media: '(min-width: 768px)',
      width: 290,
      height: 360,
      cropMode: 'noCrop',
    },
    {
      media: '(max-width: 767px)',
      width: 335,
      height: 410,
      cropMode: 'noCrop',
    },
  ];
  return (
    <Link href={`/restaurants/${restaurant._id}/${restaurant.sysName}`}>
      <a>
        <div className={styles.wrapper}>
          <Picture className={styles.image} srcSet={imgSrcSet} image={restaurant.image} />
          <div className={styles.info}>
            <div className={styles.badge}>Ресторан</div>
            <LinesEllipsis
              text={restaurant.name}
              maxLine={orientation === 'mobile' ? 2 : 4}
              ellipsis='...'
              trimRight
              basedOn='letters'
              className={styles.title}
            />
            <LinesEllipsis
              className={styles.description}
              text={restaurant.description}
              maxLine={themeValue({ bel: orientation === 'mobile' ? 5 : 6, default: 8 })}
              ellipsis='...'
              trimRight
              basedOn='letters'
            />
          </div>
        </div>
      </a>
    </Link>
  );
}
